import { pushToAdobeDataLayer } from "utils-lib/analytics/adobeDataLayer"

const QUERY_UPDATE = "global-search-query-update"

export const pushQueryUpdateData = (search, totalResults) => {
  const acdlData = {
    clicks: {
      object_content: {
        searchTerm: search,
        totalSearchResults: totalResults,
        siteSearch: "Global",
        eventName: QUERY_UPDATE,
      },
    },
  }

  pushToAdobeDataLayer(QUERY_UPDATE, acdlData)
}
